// 阿拉伯语
const ar = {
    // 首页-激活说明
    activateExplain: {
        title: 'قم بتفعيل الضمان الممتد الخاص بك واحصل على الهدية الخاصة لك',
        desp: 'الحالة التطبيقية: للتأهل ، يوافق العملاء على مشاركة تجربة التسوق الخاصة بهم مع منتجاتنا التي تم شراؤها والتي تم استخدامها بنشاط لمدة أسبوع على الأقل.',
        conditions: [
            'فقط للعملاء الذين اشتروا المنتجات على Amazon',
            'يمكن لكل عميل الحصول على هدية مجانية واحدة لمنتج واحد فقط. (مما يعني أنه بغض النظر عن عدد المرات التي تشتري فيها نفس المنتج ، يمكنك الحصول على هدية مجانية واحدة فقط).',
        ]
    },
    // 首页-激活表单
    activateForm: {
        title: 'قم بتفعيل الضمان الممتد الخاص بك واحصل على هدية مجانية الآن！',
        desp: 'متاح فقط للعملاء الحاليين',
        name: 'الاسم',
        namePlaceholder: `أدخل اسم المستلم`,
        nameErrMsg: `الاسم غير صحيح.`,
        email: 'البريد الإلكتروني',
        emailPlaceholder: `أدخل بريدك الإلكتروني`,
        emailErrMsg: `البريد الإلكتروني غير صحيح.`,
        verifCode: 'رمز التحقق',
        verifCodePlaceholder: `أدخل رمز التحقق الخاص بك`,
        verifCodeErrMsg: `رمز التحقق غير صحيح.`,
        btnSendCode: `أرسل رمز التحقق`,
        countdownMsg: `إعادة الإرسال في {countdown} ثانية`,
        orderId: 'معرّف الطلب',
        orderIdPlaceholder: `أدخل معرّف الطلب`,
        orderIdErrMsg: `معرّف الطلب غير صحيح.`,
        orderAppliedError: `تم تطبيق هذا الطلب بالفعل للحصول على هدية.`,
        skuAppliedError: `تم جمع هدية هذا الطلب.`,
        orderIdHelp: 'كيف تجد معرف طلبك؟',
        btnAactivate: 'نشط الآن',
        statement: 'نحن بالتأكيد لن نشارك معلوماتك الشخصية مع الآخرين.',
        orderIdErrPopoverMsg: 'إذا كان معرف طلبك صحيحًا بالتأكيد ، يرجى الاتصال بخدمة العملاء عبر البريد الإلكتروني. سنساعدك على تنشيط الضمان الممتد وتأكيد ما إذا كان الحدث يغطي السوق الخاص بك.',
        priceErrPopoverMsg: 'نأسف جدًا لإخبارك أن هذا الطلب قد استخدم أقل خصم لدينا ، إذا كان هناك أي مشاكل ، مرحبًا بكم في مراسلتنا عبر البريد الإلكتروني.'
    },
    // 通用弹框
    commonModal: {
        msg: `{msg}`,
        msgContents: [
            `لا يمكن أن يتطابق اسم المستلم مع الطلب`,
            `سواء أكملت مراجعة أمازون؟`,
            `هل ترغب في المتابعة إلى Amazon للمراجعة؟`
        ],
        btnRewrite: 'اعادة كتابة',
        btnNo: 'لا',
        btnYes: 'نعم'
    },
    // 选择礼物
    chooseGift: {
        title: 'الآن ، اختر الهدية التي تريدها.',
        modalTitle: 'عذرًا ، الهدية التي اخترتها لم تعد متوفرة ، يرجى الاختيار مرة أخرى',
        btnWant: 'أريدها',
        btnStockout: 'إنتهى من المخزن'
    },
    // 订单信息
    orderInfo: {
        title: 'تهنئة! تم تفعيل الضمان الممتد الخاص بك!',
        desp: 'ما ستحصل عليه',
        orderTitle: 'معلومات طلبك',
        orderId: 'رقم التعريف الخاص بالطلب',
        productASIN: 'المنتج ASIN',
        productName: 'عنوان المنتج',
        address: 'عنوان',
        aboutGift: [
            'عن الهدية',
            'لا رسوم شحن ، لا رسوم خفية ، لا يلزم بطاقة ائتمان',
            '4 خطوات بسيطة للحصول عليها (أقل من 5 دقائق).',
            'سيتم إرسال الهدية إليك في غضون 2-5 أيام عمل بعد المطالبة بها.'
        ],
        btnWant: 'أريدها'
    },
    // 步骤1
    stepOne: {
        title: 'الخطوة 1 من 4: استبيان قصير حول الشراء.',
        questionList: [{
                id: 1,
                select_type: 'radio',
                name: 'sex',
                title: '1. أنا ...؟',
                option: [{
                        txt: 'أنثى',
                        value: 0
                    },
                    {
                        txt: 'الذكر',
                        value: 1
                    },
                    {
                        txt: 'لست متأكدا',
                        value: 2
                    }
                ]
            },
            {
                id: 2,
                select_type: 'radio',
                name: 'age',
                title: `2. ما هو عمرك؟`,
                option: [{
                        txt: 'أقل من 20',
                        value: 0
                    },
                    {
                        txt: '20-30',
                        value: 1
                    },
                    {
                        txt: '30-40',
                        value: 2
                    },
                    {
                        txt: '40-50',
                        value: 3
                    },
                    {
                        txt: '50-60',
                        value: 4
                    },
                    {
                        txt: 'أكثر من 60',
                        value: 5
                    }
                ]
            },
            {
                id: 3,
                select_type: 'radio',
                name: 'reason',
                title: '3. لماذا اخترت لنا؟',
                option: [{
                        txt: 'العلامة التجارية',
                        value: 0
                    },
                    {
                        txt: 'التصميم',
                        value: 1
                    },
                    {
                        txt: 'السعر',
                        value: 2
                    },
                    {
                        txt: 'ميزات',
                        value: 3
                    },
                    {
                        txt: 'المراجعات',
                        value: 4
                    },
                    {
                        txt: 'أسباب أخرى',
                        value: 5,
                        placeholder: 'يرجى إدخال سبب'
                    }
                ]
            },
        ],
        btnNext: 'الخطوة التالية'
    },
    // 步骤2
    stepTwo: {
        title: 'الخطوة 2 من 4: أخبرنا بتجربتك حول المنتج.',
        despOne: `التصنيف العام؟`,
        despTwo: `دعنا نعرف كيف تعمل منتجاتنا من أجلك.`,
        notice: `(يرجى إدخال 10 أحرف على الأقل)`,
        commentPlaceholder: 'أدخل تعليقك',
        commentErrMsg: `لا يمكن أن تتجاوز كلمات التعليق 20000`,
        btnNext: 'الخطوة التالية',
        btnPrev: 'الخطوة السابقة'
    },
    // 步骤3
    stepThree: {
        title: 'الخطوات 3 من 4: شارك تجربة التسوق الخاصة بك مع الآخرين.',
        desp: 'فقط يأخذك بضع ثوان. ستساعد تعليقاتك العملاء الآخرين على اتخاذ قرار أفضل بالتسوق. شكرا على التفهم والدعم.',
        commentTitle: 'تعليقاتك',
        defaultComment: 'أنا أحب منتجك كثيرا!',
        btnCopyPost: 'انقر هنا لنسخ ونشر عرض amazom الخاص بك'
    },
    // 步骤4
    stepFour: {
        title: 'الخطوة 4 من 4: تأكيد عنوانك.',
        desp: 'ما ستحصل عليه',
        fullName: 'الاسم الكامل',
        fullNamePlaceholder: `أدخل اسمك الكامل`,
        fullNameErrMsg: `الاسم الكامل غير صحيح`,
        phone: 'الهاتف',
        phonePlaceholder: `أدخل هاتفك`,
        phoneErrMsg: `الهاتف غير صحيح`,
        email: 'البريد الإلكتروني',
        emailPlaceholder: `أدخل بريدك الإلكتروني`,
        emailErrMsg: `البريد الإلكتروني غير صحيح`,
        address: 'العنوان',
        addressPlaceholder: `أدخل عنوانك`,
        addressErrMsg: `العنوان غير صحيح`,
        streetPlaceholder:`عنوان الشارع`,
        apartmentPlaceholder:`حدة سكنية`,
        cityPlaceholder:`مدينة`,
        regionPlaceholder: `اختر مقاطعة`,
        countryPlaceholder: `اختر دولة`,
        postcode: 'الرمز البريدي',
        postcodePlaceholder: `أدخل الرمز البريدي الخاص بك`,
        postcodeErrMsg: `الرمز البريدي غير صحيح`,
        btnComfirm: 'تأكد'
    },
    // 完成礼物申请
    completeApplication: {
        title: `لقد أنهيت تطبيق الهدية المجاني`,
        msgs: [
            'سيتم شحن الهدية المجانية في 2-5 أيام عمل.',
            'سيتم إرسال الهدية المجانية إلى بريدك الإلكتروني ',
            ' في 2-5 أيام عمل. شكرًا جزيلاً لك على شراء منتجاتنا ، ثم سيكون هناك اتصال مخصص لفريق ما بعد البيع.',
            'أي مشاكل أخرى قد تحصل عليها ، يرجى الاتصال بخدمة العملاء عن طريق البريد الإلكتروني أو زيارة موقعنا الرسمي.',
            'نظرًا لأنك غير راضٍ تمامًا عن منتجاتنا ، يمكنك الاتصال بخدمة العملاء عبر البريد الإلكتروني أو زيارة موقعنا الرسمي ، سيكون هناك مهنيون لخدمتك. رضا العملاء بنسبة 100 ٪ هو ضماننا!'
        ],
        btnComfirm: 'تأكد'
    },
    // 获取订单号指导
    guide: {
        title: 'كيف تجد معرف الطلب الخاص بك؟',
        desps: [
            `الخطوة 1: قم بتسجيل الدخول إلى حسابك على أمازون وانقر على "طلبك" في صفحة الحساب والقوائم`,
            `الخطوة 2: انقر على "تفاصيل الطلب" في الطلب الصحيح`,
            `الخطوة 3: سترى معرف الطلب الخاص بك`
        ],
        btnOK: 'حسنا'
    }
}

export default ar